import { getDateBeforeToday } from '@utils/getDateBeforeToday';

export const DEFAULT_FILTER_DATE = getDateBeforeToday(3);

export const DEFAULT_TIMEBAND_VALUE = 'allDay';
